import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableFooter from "@material-ui/core/TableFooter";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import TableHead from "@material-ui/core/TableHead";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";
import TableGpwisSkeleton from "./TableGpwisSkeleton";

const useStyles1 = makeStyles((theme) => ({
    root: {
        flexShrink: 0,
        marginLeft: theme.spacing(0),
    },
}));

function TablePaginationActions(props) {
    const classes = useStyles1();
    const theme = useTheme();
    const { count, page, rowsPerPage, onChangePage } = props;

    const handleFirstPageButtonClick = (event) => {
        onChangePage(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onChangePage(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onChangePage(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onChangePage(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <div className={classes.root}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === "rtl" ? (
                    <KeyboardArrowRight />
                ) : (
                    <KeyboardArrowLeft />
                )}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === "rtl" ? (
                    <KeyboardArrowLeft />
                ) : (
                    <KeyboardArrowRight />
                )}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </div>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onChangePage: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

function createData(name, calories, fat) {
    return { name, calories, fat };
}

// const rows = [
//   createData("Cupcake", 305, 3.7),
//   createData("Donut", 452, 25.0),
//   createData("Eclair", 262, 16.0),
//   createData("Frozen yoghurt", 159, 6.0),
//   createData("Gingerbread", 356, 16.0),
//   createData("Honeycomb", 408, 3.2),
//   createData("Ice cream sandwich", 237, 9.0),
//   createData("Jelly Bean", 375, 0.0),
//   createData("KitKat", 518, 26.0),
//   createData("Lollipop", 392, 0.2),
//   createData("Marshmallow", 318, 0),
//   createData("Nougat", 360, 19.0),
//   createData("Oreo", 437, 18.0),
// ].sort((a, b) => (a.calories < b.calories ? -1 : 1));

const useStyles2 = makeStyles({
    b: {
        whiteSpace: "nowrap"
    },
    table: {
        minWidth: "100%",
        whiteSpace: "nowrap"
    },
    toobarBgColor: {
        "& .MuiToolbar-regular": {
            background: "#fff",
        },
    },
    container: {
        maxHeight: "340px",
        minHeight: "340px",
        overflowY: "hidden",
        "&:hover": {
            overflowY: "auto",
            "&::-webkit-scrollbar": {
                width: "4px",
            },

            /* Track */

            "&::-webkit-scrollbar-track": {
                background: "#fff",
            },

            /* Handle */

            "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#d4d8da",
                borderRadius: "20px",
                // border: "3px solid orange",
            },

            /* Handle on hover */

            "&::-webkit-scrollbar-thumb:hover": {
                background: "",
            },
        },
    },
});
const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.common.white,
        color: theme.palette.primary.main,
    },
    body: {
        fontSize: 14,
    },
    b: {
        whiteSpace: "nowrap"
    }
}))(TableCell);

export default function TableGpwisJobDetailsComponent(props) {
    const classes = useStyles2();
    const [page, setPage] = React.useState(0);
    // let array = [{ invoicedate: "1", count: "1" }];
    const [array, setArray] = React.useState([
        { invoicedate: "No Data", count: "No Data" },
    ]);

    const [rowsPerPage, setRowsPerPage] = React.useState(5);
    const [gpwisLoading, setGpwisLoading] = React.useState(true);
    useEffect(() => {
        setGpwisLoading(props.gpwisLoading)
        if (props.allGpwisJobDetails) {
            //  
            setArray(props.allGpwisJobDetails);
        } else {
            setArray([{
                createddate: "No Data",
                circuit_name: "No Data",
                rake_name: "No Data",
                cycle_id: "No Data",
                leg_no: "No Data",
                origin: "No Data",
                origin_code: "No Data",
                destination: "No Data",
                destination_code: "No Data",
                commodity: "No Data",
                job_at_destination: "No Data",
                rake_arrival_at_serving_station_datetime: "No Data",
                rake_arrival_at_station_datetime: "No Data",
                rake_placement_datetime: "No Data",
                rr_no: "No Data",
                rr_date: "No Data",
                rr_amount: "No Data",
                rr_actual_weight: "No Data",
                rr_chargeable_quantity: "No Data",
                rake_departure_datetime_from_station: "No Data",
                rake_departure_datetime_from_serving_station: "No Data",
                unloading_start_datetime: "No Data",
                unloading_completion_datetime: "No Data",
                no_of_wagons_unloaded: "No Data",
                quantity_of_cargo: "No Data",
                loading_start_datetime: "No Data",
                loading_end_datetime: "No Data",
                no_of_wagons_loaded: "No Data",
                loading_quantity_of_cargo: "No Data"
            }]);
        }

        // setArray(props.allGpwisJobDetails);
        //  
    }, [props]);
    const emptyRows =
        rowsPerPage - Math.min(rowsPerPage, array.length - page * rowsPerPage);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <div>
            <TableContainer component={Paper} className={classes.container}>
                <Table
                    className={classes.table}
                    aria-label="simple table"
                    stickyHeader
                >
                    {gpwisLoading ? (
                        <TableGpwisSkeleton />
                    ) : (
                        <div>
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell>
                                        <b> Job Created Date</b>
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        <b>Job Id</b>
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        <b>Circuit Name</b>
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                        <b>Rake Name</b>
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                        <b>Cycle ID</b>
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                        <b>Leg No.</b>
                                    </StyledTableCell><StyledTableCell align="center">
                                        <b>Origin</b>
                                    </StyledTableCell><StyledTableCell align="center">
                                        <b>Origin Code</b>
                                    </StyledTableCell><StyledTableCell align="center">
                                        <b>Destination</b>
                                    </StyledTableCell><StyledTableCell align="center">
                                        <b>Destination Code</b>
                                    </StyledTableCell><StyledTableCell align="center">
                                        <b>Commodity</b>
                                    </StyledTableCell><StyledTableCell align="center">
                                        <b>Job at Destination</b>
                                    </StyledTableCell><StyledTableCell align="center">
                                        <b>Arrival at Serving Station Date Time</b>
                                    </StyledTableCell><StyledTableCell align="center">
                                        <b>Arrival at Station Date Time</b>
                                    </StyledTableCell><StyledTableCell align="center">
                                        <b>Rake Placement Date Time</b>
                                    </StyledTableCell><StyledTableCell align="center">
                                        <b>RR No.</b>
                                    </StyledTableCell><StyledTableCell align="center">
                                        <b>RR Date</b>
                                    </StyledTableCell><StyledTableCell align="center">
                                        <b>RR Amount</b>
                                    </StyledTableCell><StyledTableCell align="center">
                                        <b>RR Actual Weight</b>
                                    </StyledTableCell><StyledTableCell align="center">
                                        <b>Chargeable Wt.</b>
                                    </StyledTableCell><StyledTableCell align="center">
                                        <b>Rake Dep. Time from Stn.</b>
                                    </StyledTableCell><StyledTableCell align="center">
                                        <b>Rake Dep. Time from Serv. Stn.</b>
                                    </StyledTableCell><StyledTableCell align="center">
                                        <b>Unloading Start Date Time</b>
                                    </StyledTableCell><StyledTableCell align="center">
                                        <b>Unloading End Date Time</b>
                                    </StyledTableCell><StyledTableCell align="center">
                                        <b>No. of wagons unloaded</b>
                                    </StyledTableCell><StyledTableCell align="center">
                                        <b>Quantity of Cargo (MT)</b>
                                    </StyledTableCell><StyledTableCell align="center">
                                        <b>Loading Start Time</b>
                                    </StyledTableCell><StyledTableCell align="center">
                                        <b>Loading End Time</b>
                                    </StyledTableCell><StyledTableCell align="center">
                                        <b>No. of wagons loaded</b>
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                        <b>Quantity of Cargo (MT)</b>
                                    </StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {(rowsPerPage > 0
                                    ? array.slice(
                                        page * rowsPerPage,
                                        page * rowsPerPage + rowsPerPage
                                    )
                                    : array
                                ).map((row) => (
                                    <TableRow>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.createddate ? (
                                                        <b>{row.createddate}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>
                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.job_id ? (
                                                        <b>{row.job_id}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>
                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.circuit_name ? (
                                                        <b>{row.circuit_name}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>
                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.rake_name ? (
                                                        <b>{row.rake_name}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.cycle_id ? (
                                                        <b>{row.cycle_id}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.leg_no ? (
                                                        <b>{row.leg_no}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.origin ? (
                                                        <b>{row.origin}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.origin_code ? (
                                                        <b>{row.origin_code}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.destination ? (
                                                        <b>{row.destination}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.destination_code ? (
                                                        <b>{row.destination_code}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.commodity ? (
                                                        <b>{row.commodity}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.job_at_destination ? (
                                                        <b>{row.job_at_destination}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.rake_arrival_at_serving_station_datetime ? (
                                                        <b>{row.rake_arrival_at_serving_station_datetime}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.rake_arrival_at_station_datetime ? (
                                                        <b>{row.rake_arrival_at_station_datetime}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.rake_placement_datetime ? (
                                                        <b>{row.rake_placement_datetime}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.rr_no ? (
                                                        <b>{row.rr_no}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.rr_date ? (
                                                        <b>{row.rr_date}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.rr_amount ? (
                                                        <b>{row.rr_amount}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.rr_actual_weight ? (
                                                        <b>{row.rr_actual_weight}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.rr_chargeable_quantity ? (
                                                        <b>{row.rr_chargeable_quantity}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.rake_departure_datetime_from_station ? (
                                                        <b>{row.rake_departure_datetime_from_station}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.rake_departure_datetime_from_serving_station ? (
                                                        <b>{row.rake_departure_datetime_from_serving_station}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.unloading_start_datetime ? (
                                                        <b>{row.unloading_start_datetime}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.unloading_completion_datetime ? (
                                                        <b>{row.unloading_completion_datetime}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.no_of_wagons_unloaded ? (
                                                        <b>{row.no_of_wagons_unloaded}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.quantity_of_cargo ? (
                                                        <b>{row.quantity_of_cargo}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.loading_start_datetime ? (
                                                        <b>{row.loading_start_datetime}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.loading_end_datetime ? (
                                                        <b>{row.loading_end_datetime}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.no_of_wagons_loaded ? (
                                                        <b>{row.no_of_wagons_loaded}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        <TableCell align="center">
                                            <div>
                                                {
                                                    row.loading_quantity_of_cargo ? (
                                                        <b>{row.loading_quantity_of_cargo}</b>
                                                    ) : (
                                                        <b>-</b>
                                                    )
                                                }

                                            </div>

                                        </TableCell>
                                        {/* <TableCell align="center">{0}</TableCell> */}
                                    </TableRow>

                                ))}

                                {emptyRows > 0 && (
                                    <TableRow style={{ height: 53 * emptyRows }}>
                                        <TableCell colSpan={6} />
                                    </TableRow>
                                )}
                            </TableBody>
                        </div>
                    )}
                    <TableFooter>
                        <TableRow></TableRow>
                    </TableFooter>
                </Table>
            </TableContainer>
            <TableContainer>
                <TablePagination
                    className={classes.toobarBgColor}
                    rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
                    component="div"
                    count={array.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    SelectProps={{
                        inputProps: { "aria-label": "rows per page" },
                        native: true,
                    }}
                    onChangePage={handleChangePage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                    ActionsComponent={TablePaginationActions}
                />
            </TableContainer>
        </div>
    )
}
